import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { checkPermissions } from '../../../../lib/helper'
import { GeneralStyledContent } from '../../../../styled/common-styled'
import LangContext, { i18n } from 'modules/shared/context/langContext'
import moment from 'moment'
import axios from 'axios'
import IndexIsDirtyFilterDrawer from './IndexIsDirtyFilterDrawer'

import { loadStockBalanceIsDirty, removeLists } from '../actions'

import {
  Button,
  Table,
  Row,
  Col,
  Pagination,
  Spin,
  Badge,
  Tooltip,
  Icon,
} from 'antd'

class StockBalanceIsDirty extends Component {
  constructor(props) {
    super(props)
    this.state = {
      is_filter: false,
      filter_visible: false,
      current_page: 1,
      page: 1,
      page_size: 10,
      order_by: 'isupply_plant_stock_balance.last_update',
      order_type: 'DESC',
      filter_obj: {
        filter_obj_stock_date_start: moment().format('YYYY-MM-DD'),
        filter_obj_stock_date_end: moment().format('YYYY-MM-DD'),
        filter_obj_plant_id: '',
        filter_obj_matterial_id: '',
      },
      file_value_pdf: [],
      limit_export: 50000,
      plant_list: [],
      material_list: [],
    }

    this.columns = [
      {
        title: i18n[this.props.language].s.stockDate,
        dataIndex: 'stock_date',
        key: 'stock_date',
        sorter: true,
        width: 120,
        render: (text, record, index) => {
          return <div>{moment(text).format('DD/MM/YYYY')}</div>
        },
      },
      {
        title: i18n[this.props.language].i.isupplyPlant,
        dataIndex: 'plant_id',
        key: 'plant_code',
        sorter: true,
        width: 200,
        render: (text, record, index) => {
          return (
            <div>
              ( {record.plant_code} )<span style={{ marginLeft: '5px' }}></span>{' '}
              {record.plant_name}
            </div>
          )
        },
      },
      {
        title: i18n[this.props.language].p.productType,
        dataIndex: 'material_id',
        key: 'material_code',
        sorter: true,
        render: (text, record, index) => {
          return (
            <div>
              ( {record.material_code} )
              <span style={{ marginLeft: '5px' }}></span> {record.material_name}
            </div>
          )
        },
      },
      {
        title: i18n[this.props.language].s.stockQuantity,
        dataIndex: 'actual_qty',
        key: 'actual_qty',
        sorter: true,
        width: 150,
        render: (text, record, index) => {
          return <div>{text}</div>
        },
      },
      {
        title: i18n[this.props.language].u.unit,
        dataIndex: 'material_unit',
        key: 'material_unit',
        sorter: true,
        width: 80,
        render: (text, record, index) => {
          return <div>{i18n[this.props.language].quantityUnit[text]}</div>
        },
      },
      {
        title: i18n[this.props.language].c.created_by,
        dataIndex: 'update_by',
        key: 'update_by',
        width: 140,
        render: (text, record, index) => {
          return <div>{text}</div>
        },
      },
      {
        title: i18n[this.props.language].c.createdAt,
        dataIndex: 'created_at',
        key: 'created_at',
        width: 140,
        render: (text, record, index) => {
          return <div>{moment(text).format("DD/MM/YYYY HH:mm:ss") }</div>
        },
      },
      {
        title: i18n[this.props.language].a.action,
        dataIndex: 'action',
        key: 'Action_btn',
        width: 100,
        align: 'center',
        fixed: 'right',
        render: (text, record, index) => {
          return (
            <div>
              {checkPermissions(
                this.props.auth.profile.permissions,
                'isupplyStockBalance',
                'can_edit'
              ) == true &&
              record.stock_date == moment().format('YYYY-MM-DD') ? (
                <Tooltip
                  placement='left'
                  title={i18n[this.props.language].e.edit}
                  arrowPointAtCenter
                  style={{
                    padding: '0px 1px 0px 0px',
                    marginLeft: '5px',
                    marginRight: '5px',
                  }}
                >
                  {this.props.serviceType !== 'modalCheckSyncMorningStock' ? (
                    <Link
                      to={`/stock-balance/is-dirty/edit/${record.id}`}
                      style={{ padding: '0px 5px 0px 5px' }}
                    >
                      <Icon type='edit' />
                    </Link>
                  ) : (
                    <Button
                      type='link'
                      icon='edit'
                      onClick={() => {
                        this.props.editAction({ id: record.id })
                      }}
                    />
                  )}
                </Tooltip>
              ) : (
                ''
              )}
            </div>
          )
        },
      },
    ]
  }

  componentDidMount() {
    this.loadData(true)
    this.handleLoadPlant()
    this.handleLoadMaterial()
  }

  componentDidUpdate(prevProps, prevState) {
    // reload data หลังจากกดปุ่ม save ใน modal check sync morning stock
    if (
      this.props.serviceType === 'modalCheckSyncMorningStock' &&
      prevProps.reload_data !== this.props.reload_data &&
      this.props.reload_data === true
    ) {
      this.loadData(true)
      this.props.resetReloadData()
    }

    // โหลดข้อมูลเมื่อเปิด modal check sync morning stock
    if (
      this.props.serviceType === 'modalCheckSyncMorningStock' &&
      prevProps.visible !== this.props.visible &&
      this.props.visible === true
    ) {
      this.loadData(true)
    }
  }

  componentWillUnmount() {
    this.onRemoveLists()
  }

  onRemoveLists = () => {
    this.props.removeLists()
  }

  loadData = (loading) => {
    this.props.loadStockBalanceIsDirty(
      {
        page: this.state.current_page,
        pageSize: this.state.page_size,
        orderBy: this.state.order_by,
        orderType: this.state.order_type,
        filterObj: this.state.filter_obj,
        type: 'data',
        file_value_pdf: this.state.file_value_pdf,
        limit_export: this.state.limit_export,
        location_visibility: this.props.auth.profile.location_visibility,
        material_visibility: this.props.auth.profile.material_visibility,
        accessToken: this.props.auth.accessToken,
      },
      loading
    )
  }

  handleLoadPlant = () => {
    let self = this
    axios
      .post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-isupply-stock-balance/plant-from-plant-silo`,
        {
          location_visibility: this.props.auth.profile.location_visibility,
        },
        {
          headers: { Authorization: `Bearer ${this.props.auth.accessToken}` },
        }
      )
      .then(function(response) {
        let Location = response.data.map((location) => {
          return {
            key: location.id,
            title: `(${location.code}) ${location.name}`,
          }
        })
        self.setState({
          plant_list: [{ key: '', title: '-' }].concat(Location),
        })
      })
      .catch(function(error) {
        console.log(error)
      })
  }

  handleLoadMaterial = () => {
    let self = this
    axios
      .post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-isupply-stock-balance/material-for-filter`,
        {
          material_visibility: this.props.auth.profile.material_visibility,
          location_visibility: this.props.auth.profile.location_visibility,
        },
        {
          headers: { Authorization: `Bearer ${this.props.auth.accessToken}` },
        }
      )
      .then(function(response) {
        let Material = response.data.map((material) => {
          return {
            key: material.id,
            title: `(${material.code}) ${material.name}`,
          }
        })
        self.setState({
          material_list: [{ key: '', title: '-' }].concat(Material),
        })
      })
      .catch(function(error) {
        console.log(error)
      })
  }

  // Start Filter on column
  handleTableChange = (pagination, filters, sorter) => {
    let order_by = ''
    let order_type = ''

    if (Object.keys(sorter).length === 0 && sorter.constructor == Object) {
      this.setState({
        order_by: 'isupply_plant_stock_balance.last_update',
        order_type: 'DESC',
      })

      order_by = 'isupply_plant_stock_balance.last_update'
      order_type = 'DESC'
    } else {
      this.setState({
        order_by: sorter.columnKey,
        order_type: sorter.order == 'descend' ? 'asc' : 'desc',
      })

      order_by = sorter.columnKey
      order_type = sorter.order == 'descend' ? 'asc' : 'desc'
    }

    this.props.loadStockBalanceIsDirty(
      {
        page: this.state.current_page,
        pageSize: this.state.page_size,
        orderBy: order_by,
        orderType: order_type,
        filterObj: this.state.filter_obj,
        type: 'data',
        file_value_pdf: this.state.file_value_pdf,
        limit_export: this.state.limit_export,
        location_visibility: this.props.auth.profile.location_visibility,
        material_visibility: this.props.auth.profile.material_visibility,
        accessToken: this.props.auth.accessToken,
      },
      true
    )
  }
  // End  Filter on column

  // Start PageChange
  handlePageChange = (page, page_size) => {
    this.setState({ page: page, current_page: page, page_size: page_size })
    this.props.loadStockBalanceIsDirty(
      {
        page: page,
        pageSize: page_size,
        orderBy: this.state.order_by,
        orderType: this.state.order_type,
        filterObj: this.state.filter_obj,
        type: 'data',
        file_value_pdf: this.state.file_value_pdf,
        limit_export: this.state.limit_export,
        location_visibility: this.props.auth.profile.location_visibility,
        material_visibility: this.props.auth.profile.material_visibility,
        accessToken: this.props.auth.accessToken,
      },
      true
    )
  }

  handleonShowSizeChange = (current, page_size) => {
    this.setState({
      page: current,
      current_page: current,
      page_size: page_size,
    })
    this.props.loadStockBalanceIsDirty(
      {
        page: current,
        pageSize: page_size,
        orderBy: this.state.order_by,
        orderType: this.state.order_type,
        filterObj: this.state.filter_obj,
        type: 'data',
        file_value_pdf: this.state.file_value_pdf,
        limit_export: this.state.limit_export,
        location_visibility: this.props.auth.profile.location_visibility,
        material_visibility: this.props.auth.profile.material_visibility,
        accessToken: this.props.auth.accessToken,
      },
      true
    )
  }
  // End PageChange

  // Start Filter
  showFilterDrawer = () => {
    this.setState({
      filter_visible: true,
    })
  }

  onFilterDrawerClose = () => {
    this.setState({
      filter_visible: false,
    })
  }

  onFilterButtonClick = (e) => {
    this.setState(
      {
        filter_visible: false,
        current_page: 1,
      },
      () => {
        this.loadData(true)
      }
    )
  }

  handleFilterObjPlant = (e) => {
    this.setState({
      filter_obj: {
        ...this.state.filter_obj,
        filter_obj_plant_id: e,
      },
      is_filter: e != null && e != '',
    })
  }

  handleFilterObjMaterial = (e) => {
    this.setState({
      filter_obj: {
        ...this.state.filter_obj,
        filter_obj_matterial_id: e,
      },
      is_filter: e != null && e != '',
    })
  }

  handleFilterObjStockDate = (val) => {
    // val is array [moment, moment]
    let start = moment(val[0]).format('YYYY-MM-DD')
    let end = moment(val[1]).format('YYYY-MM-DD')

    this.setState({
      filter_obj: {
        ...this.state.filter_obj,
        filter_obj_stock_date_start: start,
        filter_obj_stock_date_end: end,
      },
      is_filter: true,
    })
  }
  // End Filter

  render() {
    const columns = this.columns.map((col) => col)
    const {
      stock_balance_is_dirty_lists,
      stock_balance_is_dirty_total,
      stock_balance_is_dirty_loading,
    } = this.props.isupplyStockBalance

    const { serviceType } = this.props

    return (
      <GeneralStyledContent>
        {serviceType !== 'modalCheckSyncMorningStock' && (
          <Row gutter={24}>
            <Col span={24}>
              <div className='header__text'>
                {
                  i18n[this.props.language].s
                    .siloSelectionSystemForMorningSalesFromBluenet
                }
              </div>
            </Col>
          </Row>
        )}
        {serviceType !== 'modalCheckSyncMorningStock' && (
          <Row gutter={24} type='flex' justify='end' style={{ height: '38px' }}>
            <Col span={22} />
            <Col span={2} align='right'>
              <Badge dot={this.state.is_filter} align='right'>
                <Button
                  icon='filter'
                  size='small'
                  align='right'
                  onClick={this.showFilterDrawer}
                >
                  <span></span>
                  <LangContext.Consumer>
                    {(i18n) => i18n.f.filter}
                  </LangContext.Consumer>
                </Button>
              </Badge>

              <IndexIsDirtyFilterDrawer
                onClose={this.onFilterDrawerClose}
                onFilterButtonClick={this.onFilterButtonClick}
                visible={this.state.filter_visible}
                default_value={{
                  stock_date_start: this.state.filter_obj
                    .filter_obj_stock_date_start,
                  stock_date_end: this.state.filter_obj
                    .filter_obj_stock_date_end,
                  plant_id: this.state.filter_obj.filter_obj_plant_id,
                  material_id: this.state.filter_obj.filter_obj_matterial_id,
                }}
                plant_list={this.state.plant_list}
                material_list={this.state.material_list}
                handleFilterObjStockDate={this.handleFilterObjStockDate}
                handleFilterObjPlant={this.handleFilterObjPlant}
                handleFilterObjMaterial={this.handleFilterObjMaterial}
              />
            </Col>
          </Row>
        )}
        <Row>
          <Spin spinning={stock_balance_is_dirty_loading}>
            <Table
              bordered
              scroll={{ x: 1000 }}
              rowKey='id'
              columns={columns}
              dataSource={stock_balance_is_dirty_lists}
              pagination={false}
              onChange={this.handleTableChange}
            />
          </Spin>
        </Row>
        <Row type='flex' justify='end' style={{ padding: '15px' }}>
          <Col span={24} align='right'>
            <Pagination
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 200]}
              defaultPageSize={this.state.page_size}
              size='small'
              current={this.state.current_page}
              total={stock_balance_is_dirty_total}
              onChange={this.handlePageChange}
              onShowSizeChange={this.handleonShowSizeChange}
            />
          </Col>
        </Row>
      </GeneralStyledContent>
    )
  }
}
export default connect(
  ({ isupplyStockBalance, auth, ui: { language } }) => ({
    isupplyStockBalance,
    auth,
    language,
  }),
  {
    loadStockBalanceIsDirty: loadStockBalanceIsDirty.request,
    removeLists,
  }
)(StockBalanceIsDirty)
